// src/store/sagas/procedureSaga.js
import { takeLatest, call, put, fork } from 'redux-saga/effects';
import {
    FETCH_PROCEDURE_DATA,
    fetchProcedureDataSuccess,
    fetchProcedureDataFailure,
} from '../modifJson/procedureActions'; // Ajustez le chemin

// Fonction pour l'appel API
async function fetchProcedureDataApi(folderName) {
    // Enlever l'extension .json si elle existe
    const cleanFolderName = folderName.replace(/\.json$/, '');
    const response = await fetch(`/api/data/${cleanFolderName}`, { credentials: 'include' });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

function* fetchProcedureDataSaga(action) {
    try {
        const { folderName } = action.payload;
        const data = yield call(fetchProcedureDataApi, folderName);
        yield put(fetchProcedureDataSuccess(data, folderName));
    } catch (error) {
        yield put(fetchProcedureDataFailure(error));
    }
}

// Saga watcher qui écoute l'action FETCH_PROCEDURE_DATA
function* watchFetchProcedureData() {
    yield takeLatest(FETCH_PROCEDURE_DATA, fetchProcedureDataSaga);
}

export default function* procedureSaga() {
    yield fork(watchFetchProcedureData);
}


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license